// extracted by mini-css-extract-plugin
export var borderRadius = "_9r-4";
export var large = "_9r-3";
export var logoContainer = "_9r-0";
export var nameLogo = "_9r-2";
export var small = "_9r-1";